/* eslint-disable no-unused-vars */
import React from 'react';
import map from 'lodash-es/map';
import Overlay from 'components/grid/overlay';
import { Resources, PossibleAction } from 'store/types';

export const useContentAdapter = (
  items: Resources,
  options?: {
    actions?: PossibleAction[];
    disableLikes?: boolean;
  }
) => {
  return map(items, (val, key) => {
    return {
      id: val._id,
      src: val.thumbnail_link,
      thumbnail: val.thumbnail_link,
      thumbnailWidth: val.thumbnail_width,
      thumbnailHeight: val.thumbnail_height,
      customOverlay: <Overlay {...options} id={key} item={val}></Overlay>,
    };
  });
};
